import type { ChangeEvent } from 'react';
import { HFBox } from '@hf/designSystem/v1';
import { OMS_SIMULATED_DATES } from './omsSimulatedDates';

/** Empty value means the live trade day. The order read then gets no date. */
const OMS_TODAY = '';

export function SimulatedTradeDate({ value, onChange }: { value: string; onChange: (date: string) => void }) {
  return (
    <HFBox
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 1.25,
        py: 0.5,
        bgcolor: '#b71c1c',
        color: '#fff',
        borderRadius: 1,
        fontSize: 12,
        fontWeight: 700,
        whiteSpace: 'nowrap',
      }}
    >
      Simulate date
      <HFBox
        component="select"
        aria-label="Simulate OMS date"
        value={value}
        onChange={(event: ChangeEvent<HTMLSelectElement>) => onChange(event.target.value)}
        sx={{
          bgcolor: '#fff',
          color: '#111',
          border: 0,
          borderRadius: 0.5,
          fontSize: 12,
          fontWeight: 600,
          py: 0.25,
        }}
      >
        <option value={OMS_TODAY}>Today</option>
        {OMS_SIMULATED_DATES.map((date) => (
          <option key={date} value={date}>
            {date}
          </option>
        ))}
      </HFBox>
    </HFBox>
  );
}
